module.exports = __webpack_public_path__ + "static/media/tearn.d71cbce2.png";